var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _ellipse, _path26, _path27, _ellipse2, _ellipse3, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _circle2, _circle3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _circle4, _circle5, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _ellipse25, _ellipse26, _ellipse27, _path36, _path37, _path38, _path39, _ellipse28, _ellipse29, _ellipse30, _ellipse31, _ellipse32, _ellipse33, _ellipse34, _path40, _path41, _path42, _path43, _ellipse35, _ellipse36, _ellipse37, _ellipse38, _ellipse39, _ellipse40, _ellipse41, _ellipse42, _ellipse43, _ellipse44, _ellipse45, _ellipse46, _ellipse47, _ellipse48, _ellipse49, _ellipse50, _ellipse51, _ellipse52, _ellipse53, _ellipse54, _ellipse55, _ellipse56, _ellipse57, _ellipse58, _ellipse59, _ellipse60, _ellipse61, _ellipse62, _ellipse63, _ellipse64, _ellipse65, _ellipse66, _ellipse67, _rect, _path44;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFruitBasket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 122,
    viewBox: "0 0 122 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 61,
    r: 61,
    fill: "#F5F7F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.4336 35.8591C101.019 41.5487 97.3468 53.5245 94.5624 58.8012H74.0181C73.4763 54.3963 76.953 47.789 78.7591 45.0359C81.995 40.9064 89.4602 33.2896 93.4336 35.8591Z",
    fill: "#43B14A",
    stroke: "#43B14A",
    strokeWidth: 0.521331
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8274 59.844L91.69 38.9907",
    stroke: "#35903B",
    strokeWidth: 1.56399,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8274 43.6826L85.6947 52.5452",
    stroke: "#35903B",
    strokeWidth: 1.56399,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.175 50.4602L82.0424 59.3228",
    stroke: "#35903B",
    strokeWidth: 1.56399,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9983 38.9907L89.0836 45.5074",
    stroke: "#35903B",
    strokeWidth: 1.56399,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9548 48.8889L86.2797 52.2816",
    stroke: "#35903B",
    strokeWidth: 1.56399,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0176 56.0051L83.3425 59.3979",
    stroke: "#35903B",
    strokeWidth: 1.56399,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9502 42.6899L89.586 45.2024",
    stroke: "#35903B",
    strokeWidth: 1.56399,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6604 42.6128C65.5664 45.2984 64.8298 57.8029 65.5982 63.7195L84.8516 70.8872C86.8962 66.9481 85.9432 59.543 85.2111 56.3328C83.6192 51.3337 79.2806 41.591 74.6604 42.6128Z",
    fill: "#43B14A",
    stroke: "#43B14A",
    strokeWidth: 0.521331
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M76.239 68.7917L75.2087 46.1567",
    stroke: "#35903B",
    strokeWidth: 1.56399,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M81.874 53.646L76.0948 60.9514",
    stroke: "#35903B",
    strokeWidth: 1.56399,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9326 61.2705L77.1534 68.5759",
    stroke: "#35903B",
    strokeWidth: 1.56399,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6099 47.7937L75.382 53.1733",
    stroke: "#35903B",
    strokeWidth: 1.56399,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M68.688 54.2927L75.6343 60.4989",
    stroke: "#35903B",
    strokeWidth: 1.56399,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9614 61.9854L75.9077 68.1915",
    stroke: "#35903B",
    strokeWidth: 1.56399,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9219 48.1375L75.0096 52.7124",
    stroke: "#35903B",
    strokeWidth: 1.56399,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6595 43.1577C51.0739 48.8473 54.7463 60.8231 57.5306 66.0998H78.0749C78.6167 61.6949 75.14 55.0876 73.3339 52.3345C70.098 48.2049 62.6329 40.5882 58.6595 43.1577Z",
    fill: "#43B14A",
    stroke: "#43B14A",
    strokeWidth: 0.521331
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2676 67.1423L60.4049 46.2891",
    stroke: "#35903B",
    strokeWidth: 1.56399,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2676 50.981L66.4003 59.8436",
    stroke: "#35903B",
    strokeWidth: 1.56399,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9199 57.7585L70.0526 66.6212",
    stroke: "#35903B",
    strokeWidth: 1.56399,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0967 46.2891L63.0114 52.8057",
    stroke: "#35903B",
    strokeWidth: 1.56399,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1401 56.1873L65.8152 59.58",
    stroke: "#35903B",
    strokeWidth: 1.56399,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0774 63.3035L68.7525 66.6962",
    stroke: "#35903B",
    strokeWidth: 1.56399,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 49.9883L62.509 52.5007",
    stroke: "#35903B",
    strokeWidth: 1.56399,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7732 27L60.3973 68.1761H34.2856H33.2813H27.8581C20.4665 64.9624 17.0117 58.1332 16.2083 55.1203L19.2211 52.965L54.7732 27Z",
    fill: "#FE3D55"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.341995,
    cy: 0.68399,
    rx: 0.341995,
    ry: 0.68399,
    transform: "matrix(0.293236 0.95604 0.95604 -0.293236 34.3293 53.989)",
    fill: "#C01F33"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0203 53.1115C20.6272 59.8604 31.3396 67.3725 33.2813 68.176H27.8581C20.4665 64.9622 17.0117 58.133 16.2083 55.1201L19.2211 52.9648L19.0203 53.1115Z",
    fill: "#7BC103"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1702 68.1859C29.1631 68.1829 29.1559 68.1799 29.1486 68.1769C27.8887 68.1792 26.1759 68.1859 24.4447 68.1859C17.0531 64.9721 14.8034 59.3383 14 56.3254L16.4249 54.9397C18.0259 61.6639 27.1613 67.3407 29.1486 68.1769C29.409 68.1764 29.65 68.1761 29.8679 68.1761L29.1702 68.1859Z",
    fill: "#349238"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.5436,
    cy: 60.2938,
    rx: 9.00334,
    ry: 10.596,
    transform: "rotate(-39.005 43.5436 60.2938)",
    fill: "#FEFEFE"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.2244,
    cy: 61.3192,
    rx: 5.08171,
    ry: 5.77166,
    transform: "rotate(-39.005 44.2244 61.3192)",
    fill: "#FEC800"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M102.81 43.1577C110.395 48.8473 106.723 60.8231 103.939 66.0998H83.3943C82.8525 61.6949 86.3292 55.0876 88.1353 52.3345C91.3712 48.2049 98.8364 40.5882 102.81 43.1577Z",
    fill: "#43B14A",
    stroke: "#43B14A",
    strokeWidth: 0.521331
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2019 67.1423L101.065 46.2891",
    stroke: "#35903B",
    strokeWidth: 1.56399,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2019 50.981L95.0692 59.8436",
    stroke: "#35903B",
    strokeWidth: 1.56399,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5496 57.7585L91.4169 66.6212",
    stroke: "#35903B",
    strokeWidth: 1.56399,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3728 46.2891L98.4581 52.8057",
    stroke: "#35903B",
    strokeWidth: 1.56399,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M104.329 56.1873L95.6543 59.58",
    stroke: "#35903B",
    strokeWidth: 1.56399,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M101.392 63.3035L92.717 66.6962",
    stroke: "#35903B",
    strokeWidth: 1.56399,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M105.325 49.9883L98.9605 52.5007",
    stroke: "#35903B",
    strokeWidth: 1.56399,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.2326,
    cy: 62.9719,
    r: 9.12329,
    fill: "#E5ED90",
    stroke: "#4A6C23",
    strokeWidth: 0.521331
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.2292,
    cy: 62.9716,
    r: 2.73699,
    fill: "#FBFFCE"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.2316,
    cy: 59.0618,
    rx: 0.390998,
    ry: 0.781997,
    fill: "#FBFFCE"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.0994,
    cy: 59.5452,
    rx: 0.390998,
    ry: 0.781997,
    transform: "rotate(26.4698 58.0994 59.5452)",
    fill: "#FBFFCE"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.4311,
    cy: 60.6257,
    rx: 0.390998,
    ry: 0.781997,
    transform: "rotate(53.1427 59.4311 60.6257)",
    fill: "#FBFFCE"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.390998,
    cy: 0.781997,
    rx: 0.390998,
    ry: 0.781997,
    transform: "matrix(-0.895169 0.445726 0.445726 0.895169 54.5156 58.6709)",
    fill: "#FBFFCE"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.390998,
    cy: 0.781997,
    rx: 0.390998,
    ry: 0.781997,
    transform: "matrix(-0.599824 0.800132 0.800132 0.599824 52.7842 59.8438)",
    fill: "#FBFFCE"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.7856,
    cy: 64.9267,
    rx: 0.390998,
    ry: 0.781997,
    transform: "rotate(53.1427 52.7856 64.9267)",
    fill: "#FBFFCE"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.1877,
    cy: 66.583,
    rx: 0.390998,
    ry: 0.781997,
    transform: "rotate(26.4698 54.1877 66.583)",
    fill: "#FBFFCE"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.390998,
    cy: 0.781997,
    rx: 0.390998,
    ry: 0.781997,
    transform: "matrix(-0.599824 0.800132 0.800132 0.599824 59.4998 64.1448)",
    fill: "#FBFFCE"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.390998,
    cy: 0.781997,
    rx: 0.390998,
    ry: 0.781997,
    transform: "matrix(-0.895169 0.445726 0.445726 0.895169 58.4905 65.7087)",
    fill: "#FBFFCE"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.2316,
    cy: 66.8819,
    rx: 0.390998,
    ry: 0.781997,
    fill: "#FBFFCE"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.3184,
    cy: 62.5807,
    rx: 0.390998,
    ry: 0.781997,
    transform: "rotate(-90 52.3184 62.5807)",
    fill: "#FBFFCE"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.1416,
    cy: 62.5807,
    rx: 0.390998,
    ry: 0.781997,
    transform: "rotate(-90 60.1416 62.5807)",
    fill: "#FBFFCE"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.3849,
    cy: 65.5783,
    r: 9.12329,
    fill: "#E5ED90",
    stroke: "#4A6C23",
    strokeWidth: 0.521331
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.3835,
    cy: 65.5783,
    r: 2.73699,
    fill: "#FBFFCE"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.3859,
    cy: 61.6682,
    rx: 0.390998,
    ry: 0.781997,
    fill: "#FBFFCE"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.2534,
    cy: 62.1516,
    rx: 0.390998,
    ry: 0.781997,
    transform: "rotate(26.4698 74.2534 62.1516)",
    fill: "#FBFFCE"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 75.5854,
    cy: 63.2321,
    rx: 0.390998,
    ry: 0.781997,
    transform: "rotate(53.1427 75.5854 63.2321)",
    fill: "#FBFFCE"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.390998,
    cy: 0.781997,
    rx: 0.390998,
    ry: 0.781997,
    transform: "matrix(-0.895169 0.445726 0.445726 0.895169 70.6699 61.2773)",
    fill: "#FBFFCE"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.390998,
    cy: 0.781997,
    rx: 0.390998,
    ry: 0.781997,
    transform: "matrix(-0.599824 0.800132 0.800132 0.599824 68.9385 62.4502)",
    fill: "#FBFFCE"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 68.9399,
    cy: 67.5334,
    rx: 0.390998,
    ry: 0.781997,
    transform: "rotate(53.1427 68.9399 67.5334)",
    fill: "#FBFFCE"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 70.3418,
    cy: 69.1895,
    rx: 0.390998,
    ry: 0.781997,
    transform: "rotate(26.4698 70.3418 69.1895)",
    fill: "#FBFFCE"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.390998,
    cy: 0.781997,
    rx: 0.390998,
    ry: 0.781997,
    transform: "matrix(-0.599824 0.800132 0.800132 0.599824 75.6541 66.7515)",
    fill: "#FBFFCE"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.390998,
    cy: 0.781997,
    rx: 0.390998,
    ry: 0.781997,
    transform: "matrix(-0.895169 0.445726 0.445726 0.895169 74.6445 68.3152)",
    fill: "#FBFFCE"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.3859,
    cy: 69.4883,
    rx: 0.390998,
    ry: 0.781997,
    fill: "#FBFFCE"
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 68.4727,
    cy: 65.1874,
    rx: 0.390998,
    ry: 0.781997,
    transform: "rotate(-90 68.4727 65.1874)",
    fill: "#FBFFCE"
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 76.2959,
    cy: 65.1874,
    rx: 0.390998,
    ry: 0.781997,
    transform: "rotate(-90 76.2959 65.1874)",
    fill: "#FBFFCE"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M101.806 51.03L87.3662 66.0398C88.6962 68.8898 93.2941 73.1457 101.046 67.3698C108.798 61.5939 104.783 54.07 101.806 51.03Z",
    fill: "#F53353",
    stroke: "#F53353",
    strokeWidth: 1.56399,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M101.427 50.46L86.9875 65.4697C88.3175 68.3197 92.9155 72.5756 100.667 66.7997C108.419 61.0238 104.404 53.4999 101.427 50.46Z",
    fill: "#FF9B8A"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0551 55.5901C96.4471 56.3501 95.9151 58.1867 95.7251 59.0101C96.1684 59.1367 97.0551 59.618 97.0551 60.53C97.0551 61.442 95.6617 61.4167 94.9651 61.29C96.0417 62.6833 98.727 65.508 100.855 65.66C104.959 62.164 103.452 56.3501 102.185 53.8801C100.728 54.1335 97.663 54.8301 97.0551 55.5901Z",
    fill: "#F52F54"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5088 65.2797L92.4987 61.4797C92.4987 63.3037 94.1454 63.3797 94.9687 63.1897C94.842 63.5697 94.2847 65.1657 93.0687 68.5096C90.1808 68.5096 88.8255 66.3563 88.5088 65.2797Z",
    fill: "#F52F54"
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.7101,
    cy: 64.9255,
    rx: 0.353422,
    ry: 0.706844,
    transform: "rotate(32.6528 90.7101 64.9255)",
    fill: "#F1A347"
  })), _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.603,
    cy: 66.0656,
    rx: 0.353422,
    ry: 0.706844,
    transform: "rotate(32.6528 92.603 66.0656)",
    fill: "#F1A347"
  })), _ellipse30 || (_ellipse30 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.854,
    cy: 56.2763,
    rx: 0.341995,
    ry: 0.68399,
    transform: "rotate(76.0988 100.854 56.2763)",
    fill: "#F1A347"
  })), _ellipse31 || (_ellipse31 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.997,
    cy: 60.0177,
    rx: 0.341995,
    ry: 0.68399,
    transform: "rotate(107.052 100.997 60.0177)",
    fill: "#F1A347"
  })), _ellipse32 || (_ellipse32 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.7399,
    cy: 63.3471,
    rx: 0.341995,
    ry: 0.68399,
    transform: "rotate(138.955 99.7399 63.3471)",
    fill: "#F1A347"
  })), _ellipse33 || (_ellipse33 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 81.9497,
    cy: 44.5025,
    rx: 9.00334,
    ry: 11.9413,
    transform: "rotate(20.995 81.9497 44.5025)",
    fill: "#FEFEFE"
  })), _ellipse34 || (_ellipse34 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 80.6766,
    cy: 47.4888,
    rx: 5.08171,
    ry: 5.09945,
    transform: "rotate(20.995 80.6766 47.4888)",
    fill: "#FEC800"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8637 51.03L96.3035 66.0398C94.9735 68.8898 90.3756 73.1457 82.6237 67.3698C74.8718 61.5939 78.8871 54.07 81.8637 51.03Z",
    fill: "#F53353",
    stroke: "#F53353",
    strokeWidth: 1.56399,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2423 50.46L96.6821 65.4697C95.3521 68.3197 90.7542 72.5756 83.0023 66.7997C75.2504 61.0238 79.2657 53.4999 82.2423 50.46Z",
    fill: "#FF9B8A"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6146 55.5896C87.2226 56.3496 87.7546 58.1862 87.9446 59.0096C87.5013 59.1362 86.6146 59.6176 86.6146 60.5295C86.6146 61.4415 88.0079 61.4162 88.7046 61.2895C87.6279 62.6828 84.9426 65.5075 82.8147 65.6595C78.7107 62.1635 80.218 56.3496 81.4847 53.8796C82.9413 54.133 86.0066 54.8296 86.6146 55.5896Z",
    fill: "#F52F54"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1609 65.2797L91.1709 61.4797C91.1709 63.3037 89.5243 63.3797 88.701 63.1897C88.8276 63.5697 89.385 65.1657 90.601 68.5096C93.4889 68.5096 94.8442 66.3563 95.1609 65.2797Z",
    fill: "#F52F54"
  })), _ellipse35 || (_ellipse35 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.353422,
    cy: 0.706844,
    rx: 0.353422,
    ry: 0.706844,
    transform: "matrix(-0.841955 0.539547 0.539547 0.841955 92.8757 64.1396)",
    fill: "#F1A347"
  })), _ellipse36 || (_ellipse36 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.353422,
    cy: 0.706844,
    rx: 0.353422,
    ry: 0.706844,
    transform: "matrix(-0.841955 0.539547 0.539547 0.841955 90.9829 65.2798)",
    fill: "#F1A347"
  })), _ellipse37 || (_ellipse37 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.341995,
    cy: 0.68399,
    rx: 0.341995,
    ry: 0.68399,
    transform: "matrix(-0.240248 0.970712 0.970712 0.240248 82.2344 55.7798)",
    fill: "#F1A347"
  })), _ellipse38 || (_ellipse38 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.341995,
    cy: 0.68399,
    rx: 0.341995,
    ry: 0.68399,
    transform: "matrix(0.293236 0.95604 0.95604 -0.293236 81.9189 59.8918)",
    fill: "#F1A347"
  })), _ellipse39 || (_ellipse39 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.341995,
    cy: 0.68399,
    rx: 0.341995,
    ry: 0.68399,
    transform: "matrix(0.293236 0.95604 0.95604 -0.293236 21.8284 53.468)",
    fill: "#C01F33"
  })), _ellipse40 || (_ellipse40 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.341995,
    cy: 0.68399,
    rx: 0.341995,
    ry: 0.68399,
    transform: "matrix(0.293236 0.95604 0.95604 -0.293236 28.6001 48.2546)",
    fill: "#C01F33"
  })), _ellipse41 || (_ellipse41 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.341995,
    cy: 0.68399,
    rx: 0.341995,
    ry: 0.68399,
    transform: "matrix(0.293236 0.95604 0.95604 -0.293236 35.9009 42.5203)",
    fill: "#C01F33"
  })), _ellipse42 || (_ellipse42 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.341995,
    cy: 0.68399,
    rx: 0.341995,
    ry: 0.68399,
    transform: "matrix(0.293236 0.95604 0.95604 -0.293236 43.6665 36.4011)",
    fill: "#C01F33"
  })), _ellipse43 || (_ellipse43 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.341995,
    cy: 0.68399,
    rx: 0.341995,
    ry: 0.68399,
    transform: "matrix(0.293236 0.95604 0.95604 -0.293236 47.6665 33.4009)",
    fill: "#C01F33"
  })), _ellipse44 || (_ellipse44 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.341995,
    cy: 0.68399,
    rx: 0.341995,
    ry: 0.68399,
    transform: "matrix(0.293236 0.95604 0.95604 -0.293236 52.6665 30.4011)",
    fill: "#C01F33"
  })), _ellipse45 || (_ellipse45 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.341995,
    cy: 0.68399,
    rx: 0.341995,
    ry: 0.68399,
    transform: "matrix(0.293236 0.95604 0.95604 -0.293236 39.6665 39.4011)",
    fill: "#C01F33"
  })), _ellipse46 || (_ellipse46 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.341995,
    cy: 0.68399,
    rx: 0.341995,
    ry: 0.68399,
    transform: "matrix(0.293236 0.95604 0.95604 -0.293236 23.9104 57.1174)",
    fill: "#C01F33"
  })), _ellipse47 || (_ellipse47 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.341995,
    cy: 0.68399,
    rx: 0.341995,
    ry: 0.68399,
    transform: "matrix(0.293236 0.95604 0.95604 -0.293236 30.6892 51.9043)",
    fill: "#C01F33"
  })), _ellipse48 || (_ellipse48 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.341995,
    cy: 0.68399,
    rx: 0.341995,
    ry: 0.68399,
    transform: "matrix(0.293236 0.95604 0.95604 -0.293236 28.0815 56.0747)",
    fill: "#C01F33"
  })), _ellipse49 || (_ellipse49 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.341995,
    cy: 0.68399,
    rx: 0.341995,
    ry: 0.68399,
    transform: "matrix(0.293236 0.95604 0.95604 -0.293236 39.0337 44.6055)",
    fill: "#C01F33"
  })), _ellipse50 || (_ellipse50 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.341995,
    cy: 0.68399,
    rx: 0.341995,
    ry: 0.68399,
    transform: "matrix(0.293236 0.95604 0.95604 -0.293236 42.6665 41.4011)",
    fill: "#C01F33"
  })), _ellipse51 || (_ellipse51 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.341995,
    cy: 0.68399,
    rx: 0.341995,
    ry: 0.68399,
    transform: "matrix(0.293236 0.95604 0.95604 -0.293236 46.6665 38.4011)",
    fill: "#C01F33"
  })), _ellipse52 || (_ellipse52 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.341995,
    cy: 0.68399,
    rx: 0.341995,
    ry: 0.68399,
    transform: "matrix(0.293236 0.95604 0.95604 -0.293236 42.6665 47.4011)",
    fill: "#C01F33"
  })), _ellipse53 || (_ellipse53 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.341024,
    cy: 0.682047,
    rx: 0.341024,
    ry: 0.682047,
    transform: "matrix(0.293236 0.95604 0.95604 -0.293236 46.6665 44.3999)",
    fill: "#C01F33"
  })), _ellipse54 || (_ellipse54 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.341024,
    cy: 0.682047,
    rx: 0.341024,
    ry: 0.682047,
    transform: "matrix(0.293236 0.95604 0.95604 -0.293236 51.6665 41.3999)",
    fill: "#C01F33"
  })), _ellipse55 || (_ellipse55 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.341024,
    cy: 0.682047,
    rx: 0.341024,
    ry: 0.682047,
    transform: "matrix(0.293236 0.95604 0.95604 -0.293236 51.6665 35.3999)",
    fill: "#C01F33"
  })), _ellipse56 || (_ellipse56 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.341995,
    cy: 0.68399,
    rx: 0.341995,
    ry: 0.68399,
    transform: "matrix(0.293236 0.95604 0.95604 -0.293236 47.6665 50.4011)",
    fill: "#C01F33"
  })), _ellipse57 || (_ellipse57 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.341995,
    cy: 0.68399,
    rx: 0.341995,
    ry: 0.68399,
    transform: "matrix(0.293236 0.95604 0.95604 -0.293236 50.6665 48.4011)",
    fill: "#C01F33"
  })), _ellipse58 || (_ellipse58 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.341995,
    cy: 0.68399,
    rx: 0.341995,
    ry: 0.68399,
    transform: "matrix(0.293236 0.95604 0.95604 -0.293236 53.6665 46.4011)",
    fill: "#C01F33"
  })), _ellipse59 || (_ellipse59 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.341995,
    cy: 0.68399,
    rx: 0.341995,
    ry: 0.68399,
    transform: "matrix(0.293236 0.95604 0.95604 -0.293236 51.6665 52.4011)",
    fill: "#C01F33"
  })), _ellipse60 || (_ellipse60 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.341995,
    cy: 0.68399,
    rx: 0.341995,
    ry: 0.68399,
    transform: "matrix(0.293236 0.95604 0.95604 -0.293236 54.6665 50.4011)",
    fill: "#C01F33"
  })), _ellipse61 || (_ellipse61 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.341995,
    cy: 0.68399,
    rx: 0.341995,
    ry: 0.68399,
    transform: "matrix(0.293236 0.95604 0.95604 -0.293236 36.4233 48.7761)",
    fill: "#C01F33"
  })), _ellipse62 || (_ellipse62 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.341995,
    cy: 0.68399,
    rx: 0.341995,
    ry: 0.68399,
    transform: "matrix(0.293236 0.95604 0.95604 -0.293236 25.9995 51.9043)",
    fill: "#C01F33"
  })), _ellipse63 || (_ellipse63 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.341995,
    cy: 0.68399,
    rx: 0.341995,
    ry: 0.68399,
    transform: "matrix(0.293236 0.95604 0.95604 -0.293236 33.2969 46.1694)",
    fill: "#C01F33"
  })), _ellipse64 || (_ellipse64 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.341995,
    cy: 0.68399,
    rx: 0.341995,
    ry: 0.68399,
    transform: "matrix(0.293236 0.95604 0.95604 -0.293236 27.5627 60.7666)",
    fill: "#C01F33"
  })), _ellipse65 || (_ellipse65 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.341995,
    cy: 0.68399,
    rx: 0.341995,
    ry: 0.68399,
    transform: "matrix(0.293236 0.95604 0.95604 -0.293236 31.7336 57.1174)",
    fill: "#C01F33"
  })), _ellipse66 || (_ellipse66 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.341995,
    cy: 0.68399,
    rx: 0.341995,
    ry: 0.68399,
    transform: "matrix(0.293236 0.95604 0.95604 -0.293236 31.7336 62.3308)",
    fill: "#C01F33"
  })), _ellipse67 || (_ellipse67 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.341995,
    cy: 0.68399,
    rx: 0.341995,
    ry: 0.68399,
    transform: "matrix(0.754194 0.656651 0.656651 -0.754194 83.2227 63.6384)",
    fill: "#F1A347"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.1279,
    y: 64.6306,
    width: 90.1903,
    height: 3.37611,
    rx: 1.68805,
    fill: "#CED6DA"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5378 67.5734C22.0777 89.0053 40.3107 105.627 62.4258 105.627C84.5409 105.627 102.774 89.0053 105.314 67.5734H19.5378ZM105.611 63.0734C105.615 62.8614 105.616 62.6491 105.616 62.4365C105.616 62.2238 105.615 62.0115 105.611 61.7996V63.0734Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFruitBasket);
export default __webpack_public_path__ + "static/media/fruit-basket.68d6b9791746dd6703e378b2c2d2d5b0.svg";
export { ForwardRef as ReactComponent };